module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h4 class="popover-title ngeo-popup-title">\n  <span ng-bind-html="title"></span>\n  <button type="button" class="close" ng-click="open = false"> &times;</button>\n</h4>\n<div class="popover-body" ng-bind-html="content"></div>\n';

}
return __p
}